import { useCallback } from "react";
import { useFireEventMutation } from "src/api/services/patientApi";

export const useTrack = () => {
  const [fireEvent] = useFireEventMutation();

  return useCallback(
    (
      name: string,
      data: {
        [key: string]: unknown;
      }
    ) => {
      fireEvent({
        name,
        data,
      });
    },
    [fireEvent]
  );
};
